module.exports = __webpack_public_path__ + "img/download_app_teacher.830f98a0.png";